export default "__VITE_ASSET__CABTLcV9__"